import React from "react";
import { searchReportCategorys } from "../../../graphql/queries";
import * as ModelTypes from "../../../graphql/Constants/ModelTypes";
import DataGrid from "../../Common/DataGrid";
import * as DataTypes from "../../../constants/Data/DataTypes";
import * as QueryTypes from "../../../graphql/Constants/QueryTypes";

const ReportCategories = (props) => {
    return (
        <DataGrid
          {...props}
          header="Report Categories"
          gridObjectDataModel={[
            { name: "name", headerText: "Name", type: DataTypes.String },
            { name: "order", headerText: "Order", type: DataTypes.Number },
            {
              name: "createdAt",
              headerText: "Created At",
              type: DataTypes.DateTime,
            },
          ]}
          modelType={ModelTypes.ReportCategory}
          queryFunction={searchReportCategorys}
          queryFunctionType={QueryTypes.Search}
          queryName={"searchReportCategorys"}
          hasCreate={true}
          hasDetails={true}
          hasEdit={true}
          hasDelete={true}
          baseRoute={"reportCategories"}
        />
      );
};

export default ReportCategories;
